import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import TopNavigation from "../../../components/TopNavigation";
import * as PageRoutes from "../../../utils/route_pages";
import * as Assets from "../../../utils/svg_assets";
import { priceDecimal } from "../../../utils/utilities";
import "./style.scss";
import { Form, Row, Col, ListGroup, Button } from "react-bootstrap";
import { VoucherPointDM } from "../../../data_model/voucher_point_dm";
import { useNavigate } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import HeaderLayout, { DefaultLeading } from "../../../components/HeaderLayout";
import { useParams } from "react-router";
import ApiUtils from "../../../utils/api_utils";

export const VoucherPointItem = ({ data, url_category, totalPoint }) => {
  const navigate = useNavigate();
  let voucher = VoucherPointDM.fromJson(data);
  let voucherPathDetail = `/reward/voucher/${url_category}/detail/${data.pk}`;

  return (
    <ListGroup.Item>
      <Row>
        <Col xs={3} sm={3} md={3} className="div-voucher-list">
          <img
            src={
              voucher.thumbnail_img_url
                ? ApiUtils.validateImgUrl({ url: voucher.thumbnail_img_url })
                : Assets.iconTokopedia
            }
            className="voucher-image"
            alt="voucher_image"
          />
        </Col>
        <Col xs={6} sm={6} md={6} className="voucher-list-detail">
          <div className="voucher-list-title">{voucher.name}</div>
          <div className="voucher-list-info">
            <div dangerouslySetInnerHTML={{ __html: voucher.description }} />
          </div>
          <Row className="voucher-list-point">
            <Col xs={2} sm={2} md={2}>
              <img
                src={Assets.iconOval}
                className="icon-coin"
                alt="coin_image"
              />
            </Col>
            <Col xs={10} sm={10} md={10} className="point-required">
              {`${voucher.points_label} points required`}
            </Col>
          </Row>
        </Col>
        <Col xs={3} sm={3} md={3} className="redeem-button">
          <Button
            variant="danger"
            className="btn-redeem border-0"
            disabled={
              totalPoint <= data.points && data.redeemable === false
                ? true
                : false
            }
            onClick={() => {
              navigate(`${voucherPathDetail}/?previouspage=${url_category}`);
            }}
          >
            Redeem
          </Button>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

const VoucherPage = (props) => {
  const { url_category } = useParams();
  const { reward, getVoucherPoints, categories, getTotal } = props;

  const [totalPoint, setTotalPoint] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filter, setFilter] = useState({
    category: {
      slug: "",
      name: "",
      sub_categories: [],
    },
    active_filter: "all",
    temp_active_filter: "all",
  });
  const [voucherData, setVoucherData] = useState(reward?.voucherData?.results);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    getTotal()
      .then((response) => {
        setTotalPoint(response.data.points.value);
      })
      .catch(() => {
        setTotalPoint(0);
      });
  }, []);

  useEffect(() => {
    fetchData();
    if (categories && categories.length > 0) {
      let arr = [...categories];
      let category = arr.find((el) => el.slug === url_category);
      if (category) {
        // console.log(category);
        setFilter({
          ...filter,
          category: category,
        });
      }
    }
  }, []);

  const fetchData = async () => {
    let params = { category: url_category };
    if (filter.temp_active_filter !== "all") {
      params["sub_category"] = filter.temp_active_filter;
    }
    let response = await getVoucherPoints(params);
    setVoucherData(response?.data?.results);
  };

  useEffect(() => {
    const data = reward?.voucherData?.results?.filter((item) => {
      const itemName = item.name.toLowerCase();
      const itemlist = itemName.includes(searchValue.toLowerCase());
      return itemlist;
    });
    setVoucherData(data);
  }, [searchValue]);

  const handleDrawer = (isSaved) => {
    let tempfilter;
    if (isSaved) {
      tempfilter = {
        ...filter,
        active_filter: filter.temp_active_filter,
      };
      setFilter(tempfilter);
      setTimeout(() => {
        fetchData();
      }, 1000);
    } else {
      tempfilter = {
        ...filter,
        temp_active_filter: filter.active_filter,
      };
      setFilter(tempfilter);
    }
    setIsShow(false);
  };

  return (
    <div className="voucher-page">
      <div className="voucher-header">
        <TopNavigation
          titlePage={filter.category.name}
          toPath={PageRoutes.reward}
          setBorder={true}
          showRightIcon={true}
          iconLeft={Assets.iconBack}
          iconRight={Assets.iconFilter}
          onRightNavClicked={() => setIsShow(true)}
        />
      </div>
      <div className="point-available">
        You have {priceDecimal(totalPoint)} Points to redeem
      </div>
      <div className="voucher-search">
        <Form.Control
          placeholder="Search"
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
        />
      </div>
      <div className="voucher-list">
        <ListGroup>
          {voucherData
            ? voucherData.map((list, index) => (
                <VoucherPointItem
                  data={list}
                  key={`item-${index}`}
                  url_category={url_category}
                  totalPoint={totalPoint}
                />
              ))
            : ""}
        </ListGroup>
      </div>
      <Drawer
        open={isShow}
        onClose={() => setIsShow(false)}
        direction="right"
        size={400}
        enableOverlay={false}
        overlayColor={"#ffffff"}
      >
        <HeaderLayout
          key="header-voucher-point"
          title="Filter categories by"
          leading={<DefaultLeading onClick={() => handleDrawer(false)} />}
          actions={
            <div className="text-btn" onClick={() => handleDrawer(true)}>
              Done
            </div>
          }
        />
        <ListGroup>
          {filter.category.sub_categories && (
            <ListGroup.Item
              active={filter.temp_active_filter === "all"}
              onClick={() =>
                setFilter({ ...filter, temp_active_filter: "all" })
              }
            >
              All
            </ListGroup.Item>
          )}
          {filter.category.sub_categories &&
            filter.category.sub_categories.map((item, index) => (
              <ListGroup.Item
                key={`list-item-${index}`}
                active={filter.temp_active_filter === item.slug}
                onClick={() =>
                  setFilter({ ...filter, temp_active_filter: item.slug })
                }
              >
                {item.name}
              </ListGroup.Item>
            ))}
          {/* if sub categories not found */}
          {!filter.category.sub_categories && (
            <ListGroup.Item>Filter not available</ListGroup.Item>
          )}
        </ListGroup>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  reward: state.RewardSM,
  categories: state.RewardSM.categories,
  profile: state.LoginSM.login,
});

const mapDispatchToProps = (dispatch) => ({
  getVoucherPoints: dispatch.RewardSM.getVoucherPoints,
  getTotal: dispatch.FinanceSM.getTotal,
});

export default connect(mapStateToProps, mapDispatchToProps)(VoucherPage);
